var React = require('react');

function SDCSelectObject18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.65332,9.30872,5.72046,1.69128c-.396-.38023-.72-.24217-.72.30682V13.488c0,.54523.3019.66292.6709.26151l2.52319-2.8914,2.36466,4.87841a.5.5,0,0,0,.668.23183l.899-.43583a.5.5,0,0,0,.23181-.668L10,10h3.37516C13.9241,10,14.04927,9.68892,13.65332,9.30872Z","fill":"var(--iconFill, #464646)","fillRule":"evenodd"}));
}

SDCSelectObject18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCSelectObject18N;

SDCSelectObject18N.default = SDCSelectObject18N;
